<header>
  <div class="container-small">
    <div class="header">
      <div class="header__logo">
        <img src="assets/images/removia-logo-white.svg" alt="logo" />
      </div>
      <div class="lang-switcher">
        <!-- <button
          *ngFor="let l of lang.SUPPORTED_LANGS"
          (click)="lang.setLang(l)"
          [class.lang-btn-active]="lang.currentLang === l"
          class="lang-btn"
        >
          {{ l.toUpperCase() }}
        </button> -->
        <button
          class="lang-globe-btn"
          (click)="openLangModal()"
          [attr.aria-label]="'Change language'"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="2" y1="12" x2="22" y2="12" />
            <path
              d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"
            />
          </svg>
          <span class="lang-globe-label">{{
            lang.currentLang.toUpperCase()
          }}</span>
        </button>
      </div>
      <div class="header__btn">
        <a href="#plan" id="scroll-down" class="desktop button default">
          <!-- Get protected -->
          {{ "buy-now.protected" | translate }}
        </a>
        <a href="#plan" id="scroll-down-mobile" class="mobile button default">
          {{ "buy_now_long_term.plans.title-end" | translate }}
          <!-- Plan -->
        </a>
        <a href="#" target="_blank" class="button grad">
          <!-- Log in  -->
          {{ "buy-now.login" | translate }}
        </a>
      </div>
    </div>
  </div>
</header>
<app-landing-main></app-landing-main>
<!--<app-landing-pricing></app-landing-pricing>-->
<main>
  <section class="plan" id="plan" style="margin-top: 100px">
    <div class="container-extra-small">
      <div class="plan__wrapper">
        <div class="plan__list">
          <div class="plan__list__switcher">
            <div class="plan__list__switcher--inner">
              <span
                class="plan__list__switcher--premium switcher-item active"
                data-plan="premium"
              >
                <!-- Premium -->
                {{ "pricing.switcher.premium" | translate }}
              </span>
              <span
                class="plan__list__switcher--standard switcher-item"
                data-plan="standard"
              >
                <!-- Standard -->
                {{ "pricing.switcher.standard" | translate }}
              </span>
            </div>
          </div>
          <div class="plan__list__section premium active">
            <div class="plan__list__item best">
              <div class="plan__list__item--inner">
                <div class="plan__list__item--best">
                  <!-- BEST VALUE -->
                  {{ "pricing.bestValue" | translate }}
                </div>
                <div class="plan__list__item--title">Ultimate</div>
                <div class="plan__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">399</span>
                  <span class="decimal">.00</span>
                  <!--                  <span class="period">/annualy</span>-->
                </div>
                <div class="plan__list__item--price-all">
                  <span>$496</span>
                </div>
                <div class="plan__list__item--text">
                  <!-- billed annualy -->
                  {{ "pricing.billedAnnually" | translate }}
                </div>
                <div class="plan__list__item--list">
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 300 data brokers covered -->
                    {{ "pricing.plans.ultimate.features.0" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 5 emails monitored -->
                    {{ "pricing.plans.ultimate.features.1" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- You & up to 4 persons secured -->
                    {{ "pricing.plans.ultimate.features.2" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Re-checks every 90 days -->
                    {{ "pricing.plans.ultimate.features.3" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Per-user dashboard included -->
                    {{ "pricing.plans.ultimate.features.4" | translate }}
                  </div>
                </div>
                <div class="plan__list__item--check">
                  <input
                    type="radio"
                    id="ultimate"
                    name="radio-premium"
                    data-price="496"
                    data-sale="399"
                    data-attr="removia-ultimate-12-months"
                    checked
                  />
                  <label for="ultimate" class="radio-label"></label>
                </div>
              </div>
            </div>
            <div class="plan__list__item">
              <div class="plan__list__item--inner">
                <div class="plan__list__item--title">Advanced</div>
                <div class="plan__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">299</span>
                  <span class="decimal">.00</span>
                  <!--                  <span class="period">/annualy</span>-->
                </div>
                <div class="plan__list__item--price-all">
                  <span>$388</span>
                </div>
                <div class="plan__list__item--text">
                  <!-- billed annualy -->
                  {{ "pricing.billedAnnually" | translate }}
                </div>
                <div class="plan__list__item--list">
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 200 data brokers covered -->
                    {{ "pricing.plans.advanced.features.0" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 3 emails monitored -->
                    {{ "pricing.plans.advanced.features.1" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- You & up to 2 persons secured -->
                    {{ "pricing.plans.advanced.features.2" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Re-checks every 90 days -->
                    {{ "pricing.plans.advanced.features.3" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Per-user dashboard included -->
                    {{ "pricing.plans.advanced.features.4" | translate }}
                  </div>
                </div>
                <div class="plan__list__item--check">
                  <input
                    type="radio"
                    id="plus"
                    name="radio-premium"
                    data-price="388"
                    data-sale="299"
                    data-attr="removia-advanced-12-months"
                  />
                  <label for="plus" class="radio-label"></label>
                </div>
              </div>
            </div>
          </div>
          <div class="plan__list__section standard">
            <div class="plan__list__item">
              <div class="plan__list__item--inner">
                <div class="plan__list__item--title">Pro</div>
                <div class="plan__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">249</span>
                  <span class="decimal">.00</span>
                  <!--                  <span class="period">/annualy</span>-->
                </div>
                <div class="plan__list__item--price-all">
                  <span>$348</span>
                </div>
                <div class="plan__list__item--text">
                  <!-- billed annualy -->
                  {{ "pricing.billedAnnually" | translate }}
                </div>
                <div class="plan__list__item--list">
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 150 data brokers covered -->
                    {{ "pricing.plans.pro.features.0" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 2 emails monitored -->
                    {{ "pricing.plans.pro.features.1" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- You & 1 person secured -->
                    {{ "pricing.plans.pro.features.2" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Re-checks every 90 days -->
                    {{ "pricing.plans.pro.features.3" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Per-user dashboard included -->
                    {{ "pricing.plans.pro.features.4" | translate }}
                  </div>
                </div>
                <div class="plan__list__item--check">
                  <input
                    type="radio"
                    id="basic"
                    name="radio-standard"
                    data-price="348"
                    data-sale="249"
                    data-attr="removia-pro-12-months"
                    checked
                  />
                  <label for="basic" class="radio-label"></label>
                </div>
              </div>
            </div>
            <div class="plan__list__item">
              <div class="plan__list__item--inner">
                <div class="plan__list__item--title">Lite</div>
                <div class="plan__list__item--price-month">
                  <span class="currency">$</span>
                  <span class="amount">199</span>
                  <span class="decimal">.00</span>
                  <!--                  <span class="period">/annualy</span>-->
                </div>
                <div class="plan__list__item--price-all">
                  <span>$268</span>
                </div>
                <div class="plan__list__item--text">
                  <!-- billed annualy -->
                  {{ "pricing.billedAnnually" | translate }}
                </div>
                <div class="plan__list__item--list">
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 100 data brokers covered -->
                    {{ "pricing.plans.lite.features.0" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 1 email monitored -->
                    {{ "pricing.plans.lite.features.1" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- 1 person secured -->
                    {{ "pricing.plans.lite.features.2" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- Re-checks every 90 days -->
                    {{ "pricing.plans.lite.features.3" | translate }}
                  </div>
                  <div class="plan__list__item--list--item">
                    <i class="icon ion-android-done"></i>
                    <!-- User dashboard included -->
                    {{ "pricing.plans.lite.features.4" | translate }}
                  </div>
                </div>
                <div class="plan__list__item--check">
                  <input
                    type="radio"
                    id="lite"
                    name="radio-standard"
                    data-price="268"
                    data-attr="removia-lite-12-months"
                    data-sale="199"
                  />
                  <label for="lite" class="radio-label"></label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="plan__info">
          <div class="plan__info--inner" style="padding-bottom: 25px">
            <div
              class="plan__info--title"
              [innerHTML]="'pricing.title' | translate"
            >
              <!-- <span>Find the Right</span> <br />
              Plan for You -->
            </div>
            <div class="plan__info--logo">
              <img src="assets/images/logo.svg" alt="plan-logo" />
            </div>
            <div class="plan__info--pay">
              <div class="plan__info--pay--text">
                <!-- You pay today: -->
                {{ "pricing.youPayToday" | translate }}
              </div>
              <div class="plan__info--pay--sale">
                $<span class="price">496</span>
              </div>
              <div class="plan__info--pay--price">
                $<span class="sale">399</span>
              </div>
            </div>
            <div style="position: relative">
              <a
                href="#"
                class="buy button white not-scroll"
                data-cell="standard"
                data-fsc-action="Add,Checkout"
                data-fsc-item-path-value="removia-ultimate-12-months"
                target="_blank"
                role="button"
                rel="noreferrer noopener"
                aria-label="callback button"
                style="color: #ffffff"
              >
                Buy Now
              </a>
              <span class="buy-now-fake" style="color: #1f2229">
                {{ "pricing.buyNow" | translate }}
              </span>
            </div>

            <div
              class="plan__info--bottom"
              [innerHTML]="'pricing.agreement' | translate"
            >
              <!-- By clicking Buy Now you automatically agree to the Terms of Use
              and <a href="#">Privacy Policy</a> of Removia -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</main>

<app-landing-footer></app-landing-footer>
<div
  class="lang-modal-overlay"
  [class.active]="isLangModalOpen"
  (click)="closeLangModal()"
>
  <div class="lang-modal" (click)="$event.stopPropagation()">
    <div class="lang-modal__header">
      <span class="lang-modal__title">{{ "choose_language" | translate }}</span>
      <button class="lang-modal__close" (click)="closeLangModal()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <line x1="18" y1="6" x2="6" y2="18" />
          <line x1="6" y1="6" x2="18" y2="18" />
        </svg>
      </button>
    </div>
    <div class="lang-modal__list">
      <button
        *ngFor="let l of langOptions"
        class="lang-modal__item"
        [class.lang-modal__item--active]="lang.currentLang === l.code"
        (click)="selectLang(l.code)"
      >
        <span class="lang-modal__flag">{{ l.flag }}</span>
        <span class="lang-modal__name">{{ l.name }}</span>
        <span class="lang-modal__code">{{ l.code.toUpperCase() }}</span>
        <svg
          *ngIf="lang.currentLang === l.code"
          class="lang-modal__check"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="20 6 9 17 4 12" />
        </svg>
      </button>
    </div>
  </div>
</div>
